export const useDefaultData = () => {

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormClients = {
        idcliente: '',
        nombre: '',
        apellido: '',
        apellido_casado: '',
        direccion_dpi: '',
        nit:'',
        profesion: '',
        estado_civil: '',
        nacionalidad: '',
        calle: '',
        sector: '',
        lote: '',
        seccion: '',
        manzana: '',
        colonia: '',
        codigo_ingreso: '',
        zona: '',
        municipio: '',
        departamento: '',
        referencia: '',
        direccion_2: '',
        telefono: '',
        dpi: '',
        celular_1: '',
        celular_2: '',
        telefono_casa: '',
        telefono_trabajo: '',
        extension: '',
        correo: '',
        // Referencias Familiares
        nombres_familiar_1: '',
        parentesco_familiar_1: '',
        contacto_familiar_1: '',
        nombres_familiar_2: '',
        parentesco_familiar_2: '',
        contacto_familiar_2: '',
        nombres_familiar_3: '',
        parentesco_familiar_3: '',
        contacto_familiar_3: '',
        // Referencias Personales
        nombres_personal_1: '',
        parentesco_personal_1: '',
        contacto_personal_1: '',
        nombres_personal_2: '',
        parentesco_personal_2: '',
        contacto_personal_2: '',
        nombres_personal_3: '',
        parentesco_personal_3: '',
        contacto_personal_3: ''
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormClients
    })
}